import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/kendo/form-field';

interface DatePickerAreaProps extends FormlyFieldProps {
  minDate: Date;
  maxDate: Date;
}

@Component({
  selector: 'gk-formly-field-kendo-datepicker',
  template: `
    <kendo-datepicker
      calendarType="classic"
      [size]="'small'"
      [ngClass]="{ required: props.required }"
      [min]="props.minDate"
      [max]="props.maxDate"
      [formControl]="formControl"
      [formlyAttributes]="field"
      format="yyyy-MM-dd"
      [placeholder]="props.placeholder | translate"
      (valueChange)="onValueChange($event)"
    ></kendo-datepicker>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FormlyFieldKendoDatepickerComponent extends FieldType<
  FieldTypeConfig<DatePickerAreaProps>
> {
  onValueChange(value: Date): void {
    if (value) {
      const correctedDate = this.convertToLocalDate(value);
      this.formControl.setValue(correctedDate);
    }
  }

  private convertToLocalDate(date: Date): Date {
    const localDate = new Date(date);
    const tzOffset = localDate.getTimezoneOffset();
    localDate.setMinutes(localDate.getMinutes() - tzOffset);
    return localDate;
  }
}
